import React from 'react';
import { EventEmitter } from '~/core/events/EventEmitter';
import { EventFactory } from '~/core/events/EventFactory';

export const EventsContext = React.createContext<{ eventEmitter: EventEmitter; eventFactory: EventFactory } | null>(
    null
);

export const EventToolsProvider = ({ children }: { children: React.ReactNode }) => {
    const eventEmitter = new EventEmitter();
    const eventFactory = new EventFactory();
    return <EventsContext.Provider value={{ eventEmitter, eventFactory }}>{children}</EventsContext.Provider>;
};

export const useEvents = () => {
    const eventTools = React.useContext(EventsContext);
    if (!eventTools) {
        throw new Error('EventsContext is not provided');
    }
    return eventTools;
};
